import { create } from "zustand"
import { devtools, persist } from "zustand/middleware"
import { APP_ID } from "utils/constants"
import { companyService } from "services/companyService"
import { IFilterOptions } from "stores/interface"

interface IntegrationState {
  // integration: IIntegration[]
  integration: number
  isLoading: boolean
}

export interface IIntegration {
  status: string
  msg: string
  pagi: string
  record: string
  data: number
}

interface IntegrationMethods {
  // getIntegrationStatus: (params: IFilterOptions) => Promise<IIntegration[]>
  getIntegrationStatus: (params: IFilterOptions) => Promise<any>
}

export const useIntegrationStore = create<
  IntegrationState & IntegrationMethods
>()(
  devtools(
    persist(
      (set, get) => ({
        integration: 3,
        isLoading: false,
        isError: false,
        isSearching: false,
        getIntegrationStatus: async (params) => {
          set({
            isLoading: true,
          })

          try {
            // New arch returns the status id as a string; consumers compare
            // against numeric IntegrationStatus ids.
            const req = await companyService.getDirectDepositIntegrationStatus()
            const status = Number(req?.data)
            set({
              integration: status,
            })

            set({
              isLoading: false,
            })

            return status
          } catch (error) {
            console.warn(error)
            set({
              integration: 3,
            })
            return []
          }
        },
      }),
      {
        name: `${APP_ID}.accounts`,
      }
    )
  )
)
